import { MainButton } from 'elements/button/MainButton';
import { InfoCircle } from 'elements/eventView/atomic/InfoCircle';
import { TileButton } from 'elements/eventView/atomic/TileButton';
import { getExternalLinkLocalization } from 'libs/utils/logic/ui/languageLogic';
import { useAnalytics } from 'libs/utils/site/analytics';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

export const OverviewLinks = () => {
    const ctxEventView = useContext(CtxEventView);
    const analytics = useAnalytics();

    const eventData = ctxEventView.eventData;

    const validLinks = eventData.eventInfo.externalLinks?.filter((externalLink) => {
        return externalLink.url && externalLink.title;
    });
    if (!validLinks?.length) {
        return null;
    }
    if (eventData.eventInfo.externalLinkStyle === 'small') {
        return (
            <S_OverviewLinks>
                <S_LinksSmall>
                    {validLinks?.map((link) => (
                        <S_LinksSmallButton
                            key={link.url}
                            type="event-secondary2"
                            iconSet="far"
                            noOverflow={true}
                            iconName="arrow-up-right-from-square"
                            backgroundColor={eventData.eventInfo.externalLinkButtonBackground}
                            textColor={eventData.eventInfo.externalLinkButtonTextColor}
                            onClick={() => {
                                analytics.track('event_ui.external_link', {
                                    source: 'tile',
                                    destination: link.url
                                });
                                const linkUrl = link.url.startsWith('http')
                                    ? link.url
                                    : `https://${link.url}`;
                                window.open(linkUrl, '_blank', 'noreferrer');
                            }}
                        >
                            {getExternalLinkLocalization(link.title)}
                        </S_LinksSmallButton>
                    ))}
                </S_LinksSmall>
            </S_OverviewLinks>
        );
    }
    return (
        <S_OverviewLinks>
            <S_LinksLarge>
                {validLinks?.map((link) => {
                    return (
                        <TileButton
                            key={link.url}
                            externalLinkTo={link.url}
                            title={getExternalLinkLocalization(link.title)}
                            subtitle={Localization.EXTERNAL_LINK}
                            tileColor={eventData.eventInfo.styling.tileColor}
                            infoCircle={
                                <InfoCircle
                                    icon={{
                                        iconPrefix: 'far',
                                        iconName: 'arrow-up-right-from-square'
                                    }}
                                    bgColor={eventData.eventInfo.styling.circle.bgColor}
                                    iconColor={eventData.eventInfo.styling.circle.iconColor}
                                />
                            }
                        />
                    );
                })}
            </S_LinksLarge>
        </S_OverviewLinks>
    );
};

const S_OverviewLinks = styled.div``;

const S_LinksLarge = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin: 15px 0 15px 0;
`;

const S_LinksSmall = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
    margin: 15px 0 15px 0;
    width: 100%;
`;

const S_LinksSmallButton = styled(MainButton)`
    width: fit-content;
    max-width: 100%;
`;
